<template>
	<v-dialog
		v-model="requestModal"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<v-card>
			<v-toolbar>
				<v-btn icon @click="closeRequestModal">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title
					>{{ selectedRequest.method }} -
					{{ selectedRequest.name }}</v-toolbar-title
				>
				<v-spacer></v-spacer>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn
							:disbled="false"
							outline
							flat
							color="green darken-1"
							@click="makeCall"
							v-on="on"
							>SEND</v-btn
						>
					</template>
					<span>This will make an API CALL, be carefull</span>
				</v-tooltip>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab :href="`#tab-1`">Request</v-tab>
						<v-tab v-if="selectedRequest.body" :href="`#tab-2`"
							>Request Body</v-tab
						>
						<v-tab :href="`#tab-3`">Response</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item value="tab-1">
					<v-card flat>
						<v-card-text>
							<span class="headline">
								URL:
								<code>{{ getUrl() }}</code>
							</span>
							<v-container v-if="hasParams" grid-list-sm text-xs-center>
								<v-layout row wrap>
									<v-flex
										v-for="(item, index) of selectedRequest.queryParams"
										:key="item.key + '__' + index"
										xs6
									>
										<v-layout row wrap>
											<v-flex xs4>
												<span class="headline">{{ item.key }}</span>
											</v-flex>
											<v-flex xs8>
												<div v-if="item.type == 'dropDown'">
													<v-autocomplete
														v-model="modelObj[item.key]"
														:items="item.allowedValues"
														:allow-overflow="false"
														flat
														box
														placeholder="Enter key value here"
													></v-autocomplete>
												</div>
												<div v-if="item.type == 'input'">
													<v-text-field
														v-model="modelObj[item.key]"
														flat
														placeholder="Enter key value here"
														box
													></v-text-field>
												</div>
												<div v-if="item.type == 'date'">
													<v-menu
														:close-on-content-click="true"
														:nudge-right="40"
														lazy
														transition="scale-transition"
														offset-y
														full-width
														min-width="290px"
													>
														<template v-slot:activator="{ on }">
															<v-text-field
																v-model="modelObj[item.key]"
																label="Select Date"
																readonly
																v-on="on"
															></v-text-field>
														</template>
														<v-date-picker
															v-model="modelObj[item.key]"
															@input="menu2 = false"
														></v-date-picker>
													</v-menu>
												</div>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-container>
							<v-container v-else grid-list-md text-xs-center>
								<v-layout row wrap>
									<v-flex xs12>
										<v-card dark color="primary">
											<v-card-text class="px-0"
												>Cannot set Query Params
												{{ userData.name.toUpperCase() }}</v-card-text
											>
										</v-card>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="tab-2">
					<v-card flat>
						<v-card-text>
							<v-layout row wrap>
								<v-spacer></v-spacer>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											:disbled="false"
											outline
											flat
											color="blue darken-1"
											@click="formatJSON"
											v-on="on"
											>FORMAT</v-btn
										>
									</template>
									<span>FORMAT {{ userData.name.toUpperCase() }} JSON</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											:disbled="false"
											outline
											flat
											color="red darken-1"
											@click="resetJSON"
											v-on="on"
											>RESET</v-btn
										>
									</template>
									<span>RESET {{ userData.name.toUpperCase() }} JSON</span>
								</v-tooltip>
							</v-layout>
						</v-card-text>
					</v-card>
					<v-card flat>
						<v-card-text style="padding: 0px;">
							<brace
								style="height:90vh;"
								class="kbet-editor"
								:mode="'json'"
								@code-change="onBodyEditorChange"
								@setHandler="
									h => {
										bodyHandler = h;
									}
								"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="tab-3">
					<v-card flat>
						<v-card-text style="padding: 0px;">
							<brace
								style="height:90vh;"
								class="kbet-editor"
								:mode="'json'"
								@code-change="onResponseEditorChange"
								@setHandler="
									h => {
										responseHandler = h;
									}
								"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment-timezone';
import constants from '@/api';
import {
	prepareFieldFileIdsBody,
	describeFieldFileIdsResponse,
} from './field-file-ids';
export default {
	components: {},
	created() {
		this.moment = moment;
		if (this.hasParams) {
			for (let param of this.selectedRequest.queryParams) {
				if (param.type == 'date') {
					if (param.key == 'startDate') {
						this.$set(
							this.modelObj,
							param.key,
							this.moment(param.defaultValue)
								.tz('Asia/Kolkata')
								.format('YYYY-MM-DD')
						);
					} else if (param.key == 'endDate') {
						this.$set(
							this.modelObj,
							param.key,
							this.moment(param.defaultValue)
								.tz('Asia/Kolkata')
								.format('YYYY-MM-DD')
						);
					} else {
						this.$set(
							this.modelObj,
							param.key,
							param.defaultValue.substr(0, 10)
						);
					}
				} else {
					this.$set(this.modelObj, param.key, param.defaultValue);
				}
			}
		}
	},
	data() {
		return {
			tabItems: [
				{
					name: 'Request',
					tabId: 'tab-1',
					props: {},
				},
				{
					name: 'Body',
					tabId: 'tab-2',
					props: {},
				},
				{
					name: 'Response',
					tabId: 'tab-3',
					props: {},
				},
			],
			bodyHandler: false,
			responseHandler: false,
			bodyCode: {},
			reponseCode: {},
			model: 'tab-1',
			modelObj: {},
			dateModelObj: {},
			moment: {},
		};
	},
	methods: {
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapActions('requests', ['getAPICall', 'postAPICall', 'putAPICall']),
		...mapMutations('requests', ['closeRequestModal']),
		onBodyEditorChange(code) {
			this.bodyCode = code;
		},
		onResponseEditorChange(code) {
			this.reponseCode = code;
		},
		getUrl() {
			return `${constants.BASE_URL}${this.selectedRequest.url}`;
		},
		jsonValidate(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		verifySelection() {
			if (this.hasParams) {
				for (let param of this.selectedRequest.queryParams) {
					if (param.required) {
						if (this.modelObj[param.key].trim() == '') {
							this.openSnackbar({
								text: `${param.key} cannot be empty`,
							});
							return { ok: false };
						} else {
							switch (param.dataType) {
								case 'string': {
									if (typeof this.modelObj[param.key] != 'string') {
										this.openSnackbar({
											text: `${param.key} cannot be of type ${typeof this
												.modelObj[param.key]}`,
										});
										return { ok: false };
									}
									break;
								}
								case 'number': {
									if (isNaN(Number(this.modelObj[param.key]))) {
										this.openSnackbar({
											text: `${param.key} cannot be of type ${typeof this
												.modelObj[param.key]}`,
										});
										return { ok: false };
									}
									break;
								}
							}
						}
					} else {
						switch (param.dataType) {
							case 'number': {
								if (
									this.modelObj[param.key].trim() != '' &&
									isNaN(Number(this.modelObj[param.key]))
								) {
									this.openSnackbar({
										text: `${param.key} cannot be of type ${typeof this
											.modelObj[param.key]}`,
									});
									return { ok: false };
								}
								break;
							}
						}
					}
				}
			}
			if (
				(this.selectedRequest.method == 'POST' ||
					this.selectedRequest.method == 'PUT') &&
				this.selectedRequest.body &&
				!this.jsonValidate(this.bodyCode)
			) {
				this.openSnackbar({
					text: `Invalid Body, Check JSON`,
				});
				return { ok: false };
			}
			return { ok: true };
		},
		computeParams() {
			let tempParams = {};
			if (this.hasParams) {
				for (let param of this.selectedRequest.queryParams) {
					if (param.type == 'date') {
						tempParams[param.key] = this.moment(this.modelObj[param.key])
							.tz('Asia/Kolkata')
							.startOf('day')
							.toISOString();
					} else if (this.modelObj[param.key] != '') {
						tempParams[param.key] = this.modelObj[param.key];
					}
				}
			}
			return tempParams;
		},
		makeCall() {
			let result = this.verifySelection();
			if (result.ok) {
				let params = this.computeParams();
				let prepared = this.prepareBody();
				if (!prepared.ok) {
					this.openSnackbar({ text: prepared.message, time: 8000 });
					return;
				}
				let confirmText = prepared.idsMode
					? `Are you SURE you want to fetch ${prepared.count} field file id(s) "${this.userData.name.toUpperCase()}". Dates are not sent.`
					: `Are you SURE you want to make ${this.selectedRequest.name} API call "${this.userData.name.toUpperCase()}".`;
				if (window.confirm(confirmText)) {
					this.openLoaderDialog();
					// compose call here.
					switch (this.selectedRequest.method) {
						case 'GET': {
							this.getAPICall({ url: this.getUrl(), params })
								.then(data => {
									this.closeLoaderDialog();
									this.responseHandler.setValue(JSON.stringify(data, null, 2));
								})
								.catch(e => {
									this.closeLoaderDialog();
									console.log('api error', e);
								});
							break;
						}
						case 'POST': {
							this.postAPICall({
								url: this.getUrl(),
								data: prepared.body,
							})
								.then(data => {
									this.closeLoaderDialog();
									this.responseHandler.setValue(JSON.stringify(data, null, 2));
									if (prepared.idsMode) {
										this.openSnackbar({
											...describeFieldFileIdsResponse(data, prepared.count),
											time: 15000,
										});
									}
								})
								.catch(e => {
									this.closeLoaderDialog();
									console.log('api error', e);
								});
							break;
						}
						case 'PUT': {
							this.putAPICall({
								url: this.getUrl(),
								data: JSON.parse(this.bodyCode),
							})
								.then(data => {
									this.closeLoaderDialog();
									this.responseHandler.setValue(JSON.stringify(data, null, 2));
								})
								.catch(e => {
									this.closeLoaderDialog();
									console.log('api error', e);
								});
							break;
						}
					}
				}
			}
		},
		prepareBody() {
			let method = this.selectedRequest.method;
			if (method != 'POST' && method != 'PUT') {
				return { ok: true, idsMode: false };
			}
			let body = JSON.parse(this.bodyCode);
			if (this.selectedRequest.bodyPreparer == 'fieldFileIds') {
				return prepareFieldFileIdsBody(body);
			}
			return { ok: true, idsMode: false, body };
		},
		formatJSON() {
			if (this.jsonValidate(this.bodyCode)) {
				this.bodyHandler.setValue(
					JSON.stringify(JSON.parse(this.bodyCode), null, 2)
				);
			} else {
				this.openSnackbar({
					text: `Invalid Body, Check JSON`,
				});
			}
		},
		resetJSON() {
			this.bodyHandler.setValue(
				JSON.stringify(this.selectedRequest.body, null, 2)
			);
		},
	},
	mounted() {
		if (
			(this.selectedRequest.method == 'POST' ||
				this.selectedRequest.method == 'PUT') &&
			this.selectedRequest.body
		) {
			this.bodyHandler.setValue(
				JSON.stringify(this.selectedRequest.body, null, 2)
			);
		} else {
			this.bodyHandler.setValue(JSON.stringify({ no: 'value' }, null, 2));
		}
		this.responseHandler.setValue(JSON.stringify({ no: 'value' }, null, 2));
	},
	computed: {
		...mapGetters(['userData', 'getSelectedDates']),
		...mapGetters('requests', ['requestModal', 'selectedRequest']),
		hasParams() {
			return this.selectedRequest.queryParams &&
				this.selectedRequest.queryParams.length
				? true
				: false;
		},
	},
	watch: {
		modelObj: {
			deep: true,
			handler: (nv, cv) => {
				// console.log(nv, cv);
			},
		},
	},
};
</script>

<style lang="scss" scoped>
// .v-card__text {
// 	padding: 0px;
// }
</style>
